import React from "react";

const spinnerStyle = {
  width: 60,
  height: 60,
  border: "6px solid #f3f3f3",
  borderTop: "6px solid #007bff",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  margin: "0 auto 24px auto"
};

const containerStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #e0e7ff 0%, #fff 100%)"
};

const textStyle = {
  fontSize: 22,
  color: "#333",
  fontWeight: 500,
  letterSpacing: 1
};

const Loading = () => (
  <div style={containerStyle}>
    <div style={spinnerStyle} className="loading-spinner" />
    <div style={textStyle}>Loading permissions...</div>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

export default Loading; 